module.exports = __webpack_public_path__ + "static/img/green.9105d7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/green.png
// module id = FWbF
// module chunks = 8